import { InstagramIcon, AppleIcon, SpotifyIcon, WavesIcon } from '@/components/Icons';

export default function PlayerCard() {
  return (
    <section className="flex flex-col 2xl:mx-32 xl:mx-12 my-12 justify-center">
      <div className="flex flex-col md:flex-row justify-center">
        <div className="flex lg:flex-row 2xl:gap-32 gap-8 justify-center">
          {/* Left Column */}
          <div>
            <p className="mt-4 width-[380px] text-[20px] max-w-3xl leading-[140%] text-[#363636] tracking-[-0.32px]">
              Imogen Heap, a British artist, has spent 30 years self-producing music, releasing four solo albums and one with Frou Frou. She
              has collaborated with Taylor Swift, Deadmau5, and others. Her songs appear in films, TV, and are widely sampled in rap and
              dance. Heap has won two Grammys, an Ivor Novello, and pioneered the MiMu Gloves for gestural music control.
            </p>

            <div className="mt-6 flex gap-6">
              <a href="https://music.apple.com/us/artist/imogen-heap/22873602" className="opacity-70 hover:opacity-100 transition-colors">
                <AppleIcon fillColor="currentColor" className="text-[#9D9DA6] hover:text-jen-orange transition-colors" />
              </a>
              <a
                href="https://open.spotify.com/artist/6Xb4ezwoAQC4516kI89nWz?si=edsWHMlnT0qQwEWY1RL-ZQ"
                className="opacity-70 hover:opacity-100 transition-colors"
              >
                <SpotifyIcon fillColor="currentColor" className="text-[#9D9DA6] hover:text-jen-orange transition-colors" />
              </a>
              <a href="https://www.instagram.com/imogenheap/" className="opacity-70 hover:opacity-100 transition-colors">
                <InstagramIcon fillColor="currentColor" className="text-[#9D9DA6] hover:text-jen-orange transition-colors" />
              </a>
              <a href="https://tidal.com/browse/artist/3475" className="opacity-70 hover:opacity-100 transition-colors">
                <WavesIcon fillColor="currentColor" className="text-[#9D9DA6] hover:text-jen-orange transition-colors" />
              </a>
            </div>
          </div>

          {/* Right Column */}
          <div className="">
            <iframe
              style={{ borderRadius: '12px' }}
              src="https://open.spotify.com/embed/playlist/37i9dQZF1DZ06evO46XXI6?utm_source=generator&theme=0"
              width="415"
              height="352"
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
